module.exports = __webpack_public_path__ + "static/media/S1N10-5.d79636fe.svg";